<template>
  <div class="ctc-card">
    <div class="ctc-card-content">
      <h2>{{cta?.title || 'Don’t Overspend on Your MVP—Learn How'}}</h2>
      <button class="ctc-btn" @click="openPopups(cta?.link)">{{cta?.label || 'Contact us'}}</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "CtcCard",
  props: {
    openPopup: Function,
    cta: Object
  },
  methods: {
     openPopups(link) {
      if(link) {
        window.open(link, '_blank');
      } else {
        this.openPopup();
      }
     }
  }
};
</script>

<style scoped>
.ctc-card {
  background: linear-gradient(44.44deg, #ED2775 7.79%, #FF7448 94.18%
94.18%
);
  border-radius: 24px;
  padding: 32px 24px;
  color: #fff;
  max-width: 100%;
  box-shadow: 0 4px 24px rgba(123,47,242,0.08);
  display: flex;
  align-items: center;
  justify-content: center;
}
.ctc-card-content {
  text-align: left;
}
.ctc-card h2 {
  font-size: 1.4rem;
  font-weight: 700;
  margin-bottom: 24px;
  line-height: 1.3;
  color: #fff;
  font-family: inherit;
}
.ctc-btn {
  background: transparent;
  border: 2px solid #fff;
  color: #fff;
  border-radius: 32px;
  padding: 10px 32px;
  font-size: 1.1rem;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
}
.ctc-btn:hover {
  background: rgb(216, 39, 110);
  color: #fff;
}
</style> 